import { getAPIManagerInstance } from '../../../api/apiManager';
import { isNullUndefinedOrEmptyObject } from '../../../common/utils';
import { storeConfig } from './configSlice';

export const fetchConfig = (cityIdentifierPath) => {
  // This thunk loads the configuration depending on the portal type. If this is ltr or str it
  return async (dispatch, _, api) => {
    // Get the placename from the url
    const placeName = cityIdentifierPath.split(/-(s|l)tr-portal/)[0];
    // Infer the type of rental type (str, or ltr)
    const rentalType =
      cityIdentifierPath.match(/(?<rentalType>str|ltr)-portal/)[1] || 'str';
    if (!placeName) {
      return;
    }
    // Fetches the configuration from the api
    getAPIManagerInstance(placeName, rentalType);
    const expressConfig = await api.getExpressConfig();
    if (isNullUndefinedOrEmptyObject(expressConfig?.portal?.express)) {
      throw new Error('Unable to find retrieve express config');
    }
    // Stores configuration in the local store
    await dispatch(
      storeConfig({
        config: { ...expressConfig.portal, place: placeName, rentalType },
      })
    );
  };
};
